import { buildValidations, validator } from 'ember-cp-validations';

const UserValidations = buildValidations({
  code: [
    validator('presence', true),
    validator('length', {
      is: 6,
    }),
  ],
  password: [
    validator('ds-error'),
    validator('presence', true),
    validator('zxcvbn'),
    validator('length', {
      min: 9,
      messageKey: 'validations.errors.password_length_min',
    }),
  ],
});

export default UserValidations;
